/* NANACHIC THEME — JS v2 */

// ── Drawer (mobile menu)
function openDrawer() {
  document.getElementById('drawer')?.classList.add('open');
  document.getElementById('overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  document.getElementById('drawer')?.classList.remove('open');
  document.getElementById('overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Cart drawer
function openCartDrawer() {
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Share popup
function toggleShare() {
  const popup = document.getElementById('sharePopup');
  const btn = document.getElementById('shareBtn');
  const overlay = document.getElementById('shareOverlay');
  if (!popup) return;
  if (popup.classList.contains('open')) {
    closeShare();
  } else {
    popup.classList.add('open');
    overlay?.classList.add('open');
    btn?.classList.add('active');
  }
}
function closeShare() {
  document.getElementById('sharePopup')?.classList.remove('open');
  document.getElementById('shareOverlay')?.classList.remove('open');
  document.getElementById('shareBtn')?.classList.remove('active');
}
function copyShareLink() {
  navigator.clipboard?.writeText(window.location.href).catch(() => {});
  closeShare();
  const t = document.getElementById('copyToast');
  if (t) {
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 2400);
  }
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    closeShare();
    closeCartDrawer();
    closeDrawer();
  }
});

// ── Reveal animations on scroll
const obs = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      obs.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

// ── Back to top
const backTopBtn = document.createElement('button');
backTopBtn.className = 'back-top';
backTopBtn.setAttribute('aria-label', 'Retour en haut');
backTopBtn.innerHTML = '↑';
backTopBtn.onclick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
document.body.appendChild(backTopBtn);
window.addEventListener('scroll', () => {
  if (window.scrollY > 600) backTopBtn.classList.add('visible');
  else backTopBtn.classList.remove('visible');
});

// ── AJAX add to cart + drawer
async function refreshCartDrawer() {
  try {
    const res = await fetch('/?section_id=cart-drawer', { credentials: 'same-origin' });
    if (!res.ok) return;
    const html = await res.text();
    // Try parse and replace the drawer inner HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newDrawer = doc.querySelector('#cartDrawer');
    const cur = document.getElementById('cartDrawer');
    if (newDrawer && cur) cur.innerHTML = newDrawer.innerHTML;
  } catch (e) {}
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    const cart = await res.json();
    const badge = document.getElementById('cart-count');
    if (badge) badge.textContent = cart.item_count;
    // Update drawer header/footer inline
    rebuildCartDrawer(cart);
  } catch (e) {}
}

function rebuildCartDrawer(cart) {
  const body = document.getElementById('cartDrawerBody');
  if (!body) return;
  if (!cart.items || cart.items.length === 0) {
    body.innerHTML = '<p class="cart-empty">Votre panier est vide</p>';
  } else {
    body.innerHTML = cart.items.map(line => `
      <div class="cart-line">
        <div class="cart-line-img">${line.image ? `<img src="${line.image}" alt="${line.product_title}" loading="lazy" width="64" height="64">` : ''}</div>
        <div class="cart-line-info">
          <a href="${line.url}" class="cart-line-name">${line.product_title}</a>
          ${line.variant_title ? `<div style="font-size:10px;color:var(--muted);margin:2px 0">${line.variant_title}</div>` : ''}
          <div class="cart-line-price">${formatMoney(line.final_price)} × ${line.quantity}</div>
        </div>
        <a href="/cart/change?line=${line.key && line.line ? line.line : ''}&quantity=0" class="cart-line-remove" data-key="${line.key}" onclick="removeLine(event, '${line.key}')" aria-label="Retirer">×</a>
      </div>
    `).join('');
  }
  // Footer (subtotal)
  let footer = document.querySelector('.cart-drawer-footer');
  if (cart.item_count > 0) {
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'cart-drawer-footer';
      document.getElementById('cartDrawer').appendChild(footer);
    }
    footer.innerHTML = `
      <div class="cart-total-row">
        <span>Sous-total</span>
        <strong>${formatMoney(cart.total_price)}</strong>
      </div>
      <a href="/cart" class="btn-outline" style="display:block;text-align:center;margin-bottom:8px">Voir le panier</a>
      <a href="/checkout" class="btn-violet" style="display:block;text-align:center">Passer commande</a>
    `;
  } else if (footer) {
    footer.remove();
  }
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

async function removeLine(e, key) {
  e.preventDefault();
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await updateCartCount();
  } catch (er) {}
}

document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.action) return;
  if (form.action.includes('/cart/add')) {
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault();
    const data = new FormData(form);
    const btn = form.querySelector('button[type="submit"], button:not([type])');
    const origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Accept':'application/json'},
        credentials: 'same-origin',
        body: data
      });
      if (res.ok) {
        await updateCartCount();
        openCartDrawer();
        if (btn) { btn.textContent = '✓ Ajouté'; setTimeout(() => { btn.textContent = origText; btn.disabled = false; }, 1500); }
      } else {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        const err = await res.json().catch(() => ({}));
        alert(err.description || 'Erreur lors de l\'ajout au panier');
      }
    } catch (err) {
      if (btn) { btn.textContent = origText; btn.disabled = false; }
      form.submit();
    }
  }
});

// ── Wishlist / Favoris (localStorage)
const WISHLIST_KEY = 'nanachic_wishlist_v1';
function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
}
function setWishlist(list) {
  try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
}
function toggleWishlist(handle, btn) {
  const list = getWishlist();
  const idx = list.indexOf(handle);
  if (idx >= 0) {
    list.splice(idx, 1);
    if (btn) { btn.classList.remove('liked'); btn.innerHTML = '♡'; btn.setAttribute('aria-label', 'Ajouter aux favoris'); }
  } else {
    list.push(handle);
    if (btn) {
      btn.classList.add('liked');
      btn.innerHTML = '♥';
      btn.setAttribute('aria-label', 'Retirer des favoris');
      // little anim
      btn.style.transform = 'scale(1.3)';
      setTimeout(() => btn.style.transform = '', 250);
    }
  }
  setWishlist(list);
  updateWishlistCount();
}
function updateWishlistCount() {
  const count = getWishlist().length;
  document.querySelectorAll('[data-wishlist-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}
function initWishlist() {
  const list = getWishlist();
  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
    const handle = btn.dataset.wishlistToggle;
    if (list.includes(handle)) {
      btn.classList.add('liked');
      btn.innerHTML = '♥';
    }
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(handle, btn);
    });
  });
  updateWishlistCount();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlist);
} else {
  initWishlist();
}

/* ============================================================
   FIX v1 — Product page variant picker, image swap, favorites
   Restore missing handlers referenced by sections/main-product.liquid:
   - updateVariant(input, sectionId)   (was undefined)
   - selectImage(btn, sectionId)       (was undefined)
   - toggleProductFav(handle, btn)     (was undefined; alias of toggleWishlist)
   ============================================================ */
(function(){
  function fmtEUR(cents){
    if (typeof cents !== 'number') return '';
    return (cents/100).toFixed(2).replace('.', ',') + ' €';
  }

  // Main variant matcher + UI updater
  window.updateVariant = function(input, sectionId){
    var form = input.closest('form');
    if (!form) return;

    // 1) Sync .active class on labels for THIS option group only
    var optionName = input.name; // e.g. options[Couleur]
    form.querySelectorAll('input[name="' + optionName.replace(/"/g,'\\"') + '"]').forEach(function(r){
      var lbl = r.closest('.product-option-value');
      if (!lbl) return;
      if (r.checked) lbl.classList.add('active'); else lbl.classList.remove('active');
    });

    // 2) Collect all currently selected option values, ordered by data-option-index
    var picks = [];
    form.querySelectorAll('input[type="radio"][name^="options["]').forEach(function(r){
      if (!r.checked) return;
      var idx = parseInt(r.dataset.optionIndex, 10);
      if (!isNaN(idx)) picks[idx] = r.value;
    });

    // 3) Read variant JSON injected by Liquid
    var dataEl = document.getElementById('VariantData-' + sectionId);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch(e) { return; }
    if (!Array.isArray(variants)) return;

    // 4) Find matching variant: same length + every option matches
    var matched = variants.find(function(v){
      if (!v.options || v.options.length !== picks.length) return false;
      for (var i = 0; i < v.options.length; i++) {
        if (v.options[i] !== picks[i]) return false;
      }
      return true;
    });
    if (!matched) return;

    // 5) Update hidden id input (THIS is the field /cart/add reads)
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = matched.id;

    // 6) Update price
    var section = document.getElementById('ProductSection-' + sectionId);
    if (section) {
      var priceEl = section.querySelector('.product-page-price');
      if (priceEl) {
        var html = fmtEUR(matched.price);
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          html += ' <s>' + fmtEUR(matched.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
    }

    // 7) Update submit button availability + label
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      if (matched.available) {
        btn.disabled = false;
        btn.textContent = 'Ajouter au panier';
      } else {
        btn.disabled = true;
        btn.textContent = 'Épuisé';
      }
    }

    // 8) Update URL ?variant=… (no reload)
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      history.replaceState({}, '', url.toString());
    } catch(e) {}

    // 9) Swap main image if variant has its own
    if (matched.featured_image && matched.featured_image.src) {
      var mainImg = document.getElementById('MainImageTag-' + sectionId);
      if (mainImg) mainImg.src = matched.featured_image.src;
    }
  };

  // Thumbnail click → swap main image
  window.selectImage = function(btn, sectionId){
    var src = btn.dataset.img;
    if (!src) return;
    var mainImg = document.getElementById('MainImageTag-' + sectionId);
    if (mainImg) mainImg.src = src;
    var section = document.getElementById('ProductSection-' + sectionId);
    if (section) {
      section.querySelectorAll('.product-page-thumb').forEach(function(t){ t.classList.remove('active'); });
      btn.classList.add('active');
    }
  };

  // Favorites button on product page (alias of toggleWishlist with dual-state label)
  window.toggleProductFav = function(handle, btn){
    if (typeof toggleWishlist !== 'function') return;
    toggleWishlist(handle, btn);
    var liked = btn.classList.contains('liked');
    var icon = btn.querySelector('.prod-fav-icon');
    if (icon) icon.textContent = liked ? '♥' : '♡';
    var txt = btn.querySelector('.prod-fav-text');
    if (txt) txt.textContent = liked ? 'Retirer des favoris' : 'Ajouter aux favoris';
  };

  // Hydrate fav button state on page load
  function initProductFav(){
    document.querySelectorAll('[id^="prodFav-"]').forEach(function(btn){
      var handle = btn.dataset.handle;
      if (!handle) return;
      var list;
      try { list = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch(e) { list = []; }
      if (list.indexOf(handle) >= 0) {
        btn.classList.add('liked');
        var icon = btn.querySelector('.prod-fav-icon');
        if (icon) icon.textContent = '♥';
        var txt = btn.querySelector('.prod-fav-text');
        if (txt) txt.textContent = 'Retirer des favoris';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFav);
  } else {
    initProductFav();
  }
})();
